export default function () {
    const widgetName = 'secondFeatureBg';
    const widgetOpts = secondFeatureBgOpts;

    return saffire.widgets.cardWidget($(`#${widgetName}`), {
        currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
        
        cardWidgetLoaded: function (slide) {

            $(`#${widgetName} .card-widget-item`).each(function () {
                $(".second-tier-container").css("background-image", `url('${slide.items[0].ImageWithPath}')`),
                $(this).find(".image-container").remove(),
                $(this).find(".buttonwrap").remove(),
                $(this).find(".card-widget-title").remove(),
                $(this).find(".card-widget-description").remove()

            })

            $(`#${widgetName}`).remove()
            
        },
        buyNowButton: {
            visible: false,
            text: "BUY NOW"
        },
        itemsPerPanel: 1,
        hasImages: true,
        lazyLoadImages: true,
        imageIsBackground: false,
        link: [''], // [], ['all'], ['image', 'title', 'description']
        maxItemsVisible: 1,
        moreButton: {
            visible: false,
            text: "More"
        },
        scriptPath: widgetOpts.scriptPath,
        showDescription: true,
        textOverImage: false
    });
}